import React from "react";

type Option = {
  value: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  icon?: string;
  group?: string;
};

type NullOption = {
  value: string | null;
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  icon?: string;
  group?: string;
};

type Result = [Option | NullOption, (value: string | null) => void];

export const useSelectedMenuOption = (options: Option[], defaultOption: NullOption): Result => {
  const [selectedOptionValue, setSelectedOptionValue] = React.useState<string | null>(defaultOption.value);

  const selectedOption = options.find((opt) => opt.value === selectedOptionValue) ?? defaultOption;

  return [selectedOption, setSelectedOptionValue];
};
